import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolesMsalGuard } from './pages/core/shared/guards/roles-msal.guard';
import { mobileNavigationGuard } from './pages/core/shared/guards/mobile-navigation.guard';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule),
    canActivate: [MsalGuard],
    canActivateChild: [mobileNavigationGuard]
  },

  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
    canActivate: [RolesMsalGuard],
    canActivateChild: [mobileNavigationGuard],
    data: { allowedRoles: ['admin', 'superadmin'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
